var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.inputDesign == 'default')?_c('label',[_vm._v(" "+_vm._s(_vm.$t(_vm.label))+" "),(_vm.required == true)?_c('span',{staticClass:"error--text"},[_vm._v("*")]):_vm._e()]):_vm._e(),_c('ckeditor',{model:{value:(_vm.input),callback:function ($$v) {_vm.input=$$v},expression:"input"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }